import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  Avatar,
  Divider,
  Collapse,
  Button,
  Popper,
  ClickAwayListener,
} from '@mui/material';
// import { AccountCircleOutlined, ShoppingCartOutlined } from '@mui/icons-material';
import { NavLink, useLocation } from 'react-router-dom';
import {
  ExpandMoreRounded,
  LogoutOutlined,
  LogoutRounded,
  NotificationsOutlined,
  SettingsOutlined,
} from '@mui/icons-material';
import moment from 'moment';
import Colors from '../../../Configs/colors';
import Images from '../../../Configs/images';
import { clearStorage, getUserData } from '../../../Utils/storages';
import ConfirmationModal from '../ConfirmationModal';
import ROUTES from '../../../Configs/routes';
import {
  IconAdmin,
  IconCourier,
  IconCustomer,
  IconMarket, IconOverview, IconRequests, IconStorages, IconSubscription,
} from '../../../Assets/Icons';
import menuConfigs from './configs';
// import Images from '../../../Configs/images';
// import ROUTES from '../../../Configs/routes';

export default function AdminPageBase({
  children, classes, noNav, title, breadcrumbs, additionalStuff, isAdmin,
}) {
  // const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const location = useLocation();
  const userData = getUserData();
  const [value, setValue] = useState(0);

  const role = userData?.role_id?.toLowerCase();

  useEffect(() => {
    if (isAdmin) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      switch (location.pathname?.split('/')[1]) {
        case 'storage': setValue(1);
          break;
        case 'couriers': setValue(2);
          break;
        case 'market': setValue(3);
          break;
        case 'customers': setValue(4);
          break;
        case 'admins': setValue(5);
          break;
        case 'subscription': setValue(7);
          break;
        case 'settings': setValue(8);
          break;
        case 'extra-storage': setValue(11);
          break;
        case 'overview': setValue(10);
          break;
        case 'request-in':
        case 'request-out':
        case 'request': setValue(0);
          break;
        default: setValue(null);
      }
    }
  }, [location.pathname]);

  const ref = useRef(null);
  const drawerWidth = 220;
  const paperStyle = {
    minWidth: drawerWidth,
    boxSizing: 'border-box',
    bgcolor: Colors.white,
    height: '100vh',
    overflow: 'auto',
    px: 2,
    py: 4,
    color: '#282828',
  };

  const [logoutPop, setLogoutPop] = useState(false);
  const [openStorage, setOpenStorages] = useState(() => menuConfigs.openStorage);
  const [openMarket, setOpenMarket] = useState(() => menuConfigs.openMarket);
  const [openSubs, setOpenSubs] = useState(() => menuConfigs.openSubs);

  const toggleOpenStorage = () => {
    setOpenStorages(() => {
      menuConfigs.openStorage = !menuConfigs.openStorage;
      return menuConfigs.openStorage;
    });
  };

  const toggleOpenMarket = () => {
    setOpenMarket(() => {
      menuConfigs.openMarket = !menuConfigs.openMarket;
      return menuConfigs.openMarket;
    });
  };

  const toggleOpenSubs = () => {
    setOpenSubs(() => {
      menuConfigs.openSubs = !menuConfigs.openSubs;
      return menuConfigs.openSubs;
    });
  };

  const toggleLogoutPop = () => {
    setLogoutPop(!logoutPop);
  };

  const logout = () => {
    clearStorage();
    window.location.reload();
  };

  const linkClassName = (activeNumber, dropdownChild) => {
    let initialClassName = 'flex align-items-center mt-2 link';
    if (dropdownChild) {
      initialClassName += ' dropdownChild';
    }
    if (activeNumber === value) {
      initialClassName += ' active';
    }
    return initialClassName;
  };

  const renderIconColor = (activeNumber) => (activeNumber === value ? Colors.primary : '#2E3C40');
  if (isAdmin) {
    return (
      <Box ref={ref} className={classes.root}>
        {!noNav
          && (
            <Drawer
              sx={{
                minWidth: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': paperStyle,
                '& .MuiDrawer-paper::-webkit-scrollbar': {
                  display: 'none',
                },
              }}
              variant="permanent"
              anchor="left"
              className="navigation"
            >

              <div className="center">
                <img
                  src={Images.Logo}
                  alt="logo"
                  height={46}
                />
              </div>

              <Box className="primary-green" fontWeight="700" fontSize={14} mt={3}>
                {userData.role_id}
                {' '}
                Dashboard
              </Box>

              <NavLink className={linkClassName(10)} to={ROUTES.overview()}>
                <IconOverview titleAccess="overview" sx={{ fontSize: 20 }} iconcolor={renderIconColor(10)} />
                Overview
              </NavLink>

              <NavLink className={linkClassName(0)} to={ROUTES.request()}>
                <IconRequests titleAccess="requests" sx={{ fontSize: 20 }} iconcolor={renderIconColor(0)} />
                Request Order
              </NavLink>

              <Divider sx={{ my: 3 }} />

              <div className="s-18 weight-700">Managements</div>
              <div className="mt-1">
                <Box className={`flex align-items-center mt-2 dropdown ${openStorage ? 'active' : ''}`} onClick={toggleOpenStorage}>
                  <IconStorages titleAccess="storages" sx={{ fontSize: 20 }} iconcolor={openStorage ? Colors.primary : '#2E3C40'} />
                  <Box display="inline-flex" flex={1}>Storages</Box>
                  <ExpandMoreRounded sx={{ alignSelf: 'flex-end' }} />
                </Box>
                <Collapse in={openStorage}>
                  {/* <NavLink className={linkClassName(20, true)} to={ROUTES.history()}>
                    History
                  </NavLink> */}
                  <NavLink className={linkClassName(1, true)} to={ROUTES.storage()}>
                    Upgrade Storages
                  </NavLink>
                </Collapse>
                <NavLink className={linkClassName(2)} to={`${ROUTES.couriers()}/all`}>
                  <IconCourier titleAccess="courier" sx={{ fontSize: 20 }} iconcolor={renderIconColor(2)} />
                  Couriers
                </NavLink>
                {Boolean(role === 'admin')
                && (
                <>
                  <Box className={`flex align-items-center mt-2 dropdown ${openMarket ? 'active' : ''}`} onClick={toggleOpenMarket}>
                    <IconMarket titleAccess="storages" sx={{ fontSize: 20 }} iconcolor={openMarket ? Colors.primary : '#2E3C40'} />
                    <Box display="inline-flex" flex={1}>Market</Box>
                    <ExpandMoreRounded sx={{ alignSelf: 'flex-end' }} />
                  </Box>
                  <Collapse in={openMarket}>
                    <NavLink className={linkClassName(29, true)} to={ROUTES.market()}>
                      View Market
                    </NavLink>
                    <NavLink className={linkClassName(30, true)} to={`${ROUTES.myItems()}`}>
                      My Items
                    </NavLink>
                    <NavLink className={linkClassName(31, true)} to={ROUTES.requestItem()}>
                      Requested Items
                    </NavLink>
                  </Collapse>

                  <Box className={`flex align-items-center mt-2 dropdown ${openSubs ? 'active' : ''}`} onClick={toggleOpenSubs}>
                    <IconSubscription titleAccess="subscription" sx={{ fontSize: 20 }} iconcolor={openSubs ? Colors.primary : '#2E3C40'} />
                    <Box display="inline-flex" flex={1}>Subscription</Box>
                    <ExpandMoreRounded sx={{ alignSelf: 'flex-end' }} />
                  </Box>
                  <Collapse in={openSubs}>
                    {/* <NavLink className={linkClassName(6, true)} to="/">
                      History
                    </NavLink> */}
                    <NavLink className={linkClassName(7, true)} to={`${ROUTES.subscription()}`}>
                      Settings
                    </NavLink>
                  </Collapse>

                  <NavLink className={`link flex align-items-center ${value === 4 ? 'active' : ''} mt-2`} to={ROUTES.customers()}>
                    <IconCustomer titleAccess="customer" sx={{ fontSize: 20 }} iconcolor={renderIconColor(4)} />
                    Customers
                  </NavLink>

                  <NavLink className={`link flex align-items-center ${value === 5 ? 'active' : ''} mt-2`} to={ROUTES.admins()}>
                    <IconAdmin titleAccess="admin" sx={{ fontSize: 20 }} iconcolor={renderIconColor(5)} />
                    Admins
                  </NavLink>
                </>
                )}
              </div>

              <div className="s-14 weight-700 mt-5">General</div>
              <div className="mt-1">
                <NavLink className={`link flex align-items-center ${value === 8 ? 'active' : ''} mt-2`} to={ROUTES.settings()}>
                  <SettingsOutlined fontSize="small" />
                  Settings
                </NavLink>
                <div className="link flex align-items-center mt-2" onClick={toggleLogoutPop}>
                  <LogoutOutlined fontSize="small" />
                  Sign out
                </div>
              </div>
            </Drawer>
          )}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            bgcolor: '#F7F7FA',
          }}
        >
          <Box className="top-nav" sx={{ p: 3 }}>
            <div className="flex space-between align-items-center">
              <h3>{title}</h3>
              <div className="flex align-items-center gap-24">
                <div className="now-date weight-700 s-14">{moment().format('MMM DD YYYY')}</div>
                <IconButton><NotificationsOutlined /></IconButton>
                <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                  <Box>
                    <IconButton
                      sx={{ p: 0 }}
                      onClick={(e) => setAnchorEl(anchorEl ? null : e.currentTarget)}
                    >
                      <Avatar src={userData.profile_picture} />
                    </IconButton>
                    <Popper
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      placement="bottom-start"
                      sx={{ bgcolor: '#fff' }}
                    >
                      <Button
                        variant="outlined"
                        sx={{ px: 3, bgcolor: '#fff' }}
                        startIcon={<LogoutRounded sx={{ color: Colors.primary }} />}
                        className="btn-outlined"
                        onClick={toggleLogoutPop}
                      >
                        Sign Out
                      </Button>
                    </Popper>
                  </Box>
                </ClickAwayListener>
              </div>
            </div>
            {breadcrumbs}
            {additionalStuff}
          </Box>
          {children}
        </Box>
        <ConfirmationModal
          open={logoutPop}
          title="Are you sure want to sign out?"
          handleClose={toggleLogoutPop}
          handleAgree={logout}
          confirmText="Sign out"
        />
      </Box>
    );
  }

  return children;
}
